import LabelSelector, { compareLabels, Label, LabelSelection } from "./LabelSelector";

export default LabelSelector;
export { compareLabels };
export type { Label, LabelSelection };
